<template>
    <div class="reset-page">
        <div class="reset-page-container">
            <div class="reset-container">
                <img
                    :src="
                        this.whitelabel.data.imgs.img_logo != null
                            ? this.whitelabel.data.imgs.img_logo
                            : require('@/assets/logo-club.svg')
                    "
                    :alt="
                        this.whitelabel.data.imgs.img_logo != null
                            ? 'Logo'
                            : 'Logo Clube da Cotação'
                    "
                    :class="
                        this.whitelabel.data.imgs.img_logo !== null
                            ? 'img-logotipo-whitelabel'
                            : 'logo-auth'
                    "
                />
                <div class="reset-container-form">
                    <div v-if="currentStep === 'reset-email'" class="reset-email">
                        <h3>Esqueceu sua senha?</h3>
                        <span class="form-subtitle">
                            Um código será enviado para seu
                            <span v-if="recoveryType === 'email'">email</span>
                            <span v-else>WhatsApp</span> para recuperar sua senha.
                        </span>

                        <a-alert
                            v-if="error_msg"
                            :message="error_msg"
                            type="error"
                            show-icon
                            closable
                            class="alert-message"
                            @close="error_msg = ''"
                        />
                        <a-alert
                            v-if="success_msg"
                            :message="success_msg"
                            type="success"
                            show-icon
                            closable
                            class="alert-message"
                            @close="success_msg = ''"
                        />
                        <div class="form-item" :class="{ error: fieldError }">
                            <StandardSimpleInput
                                :label="recoveryType === 'email' ? 'Email' : 'Número do WhatsApp'"
                                :placeholder="
                                    recoveryType === 'email'
                                        ? 'Digite seu email'
                                        : 'Digite seu WhatsApp'
                                "
                                :error="fieldError"
                                :value="contact"
                                @input="
                                    recoveryType === 'whatsapp'
                                        ? onPhoneInput($event)
                                        : (contact = $event)
                                "
                                @clear-error="fieldError = ''"
                            />
                            <small v-if="fieldError" class="field-error">{{ fieldError }}</small>
                        </div>
                        <div class="links-reset">
                            <span v-if="recoveryType === 'email'">
                                Não lembra o e-mail?
                                <a @click="switchTowhatsApp"> Recupere pelo WhatsApp </a>
                            </span>
                            <span v-else>
                                Não lembra o número?
                                <a @click="switchToEmail"> Recupere pelo email </a> ou fale com
                                nosso
                                <a @click="show = true"> Suporte </a>
                            </span>
                        </div>
                        <AuthSubmitButton
                            :loading="loading"
                            :default-text="'Recuperar Senha'"
                            :loading-text="'Recuperando...'"
                            html-type="submit"
                            @click.native="handleSubmit"
                        />

                        <AuthBackLink />
                    </div>
                    <div class="verify-code" v-if="currentStep === 'verify-code'">
                        <h3>Confira seu {{ recoveryType === "email" ? "email" : "App" }}</h3>
                        <span class="form-subtitle">
                            Insira o código que foi enviado para
                            <strong>{{ maskedContact }}</strong>
                        </span>
                        <a-alert
                            v-if="error_msg"
                            :message="error_msg"
                            type="error"
                            show-icon
                            closable
                            class="alert-message"
                            @close="error_msg = ''"
                        />
                        <div>
                            <CodeInput @complete="handleCodeComplete" />
                        </div>
                        <a-button
                            type="primary"
                            block
                            size="large"
                            class="submit-button-code"
                            :loading="loading"
                            :disabled="resendDisabled"
                            @click="resendCode"
                        >
                            {{ resendDisabled ? `Reenviar em ${resendTimer}s` : "Reenviar Código" }}
                        </a-button>
                        <AuthBackLink />
                    </div>

                    <div class="password-container-form" v-if="currentStep === 'password-change'">
                        <div class="password-form" v-if="!showSuccess && !accountSuspended">
                            <h3>Nova Senha</h3>
                            <!-- <span class="form-subtitle">
                                Por motivos de segurança, sua senha atingiu o prazo de validade.
                                Para continuar acessando sua conta, você precisa criar uma nova
                                senha.
                            </span> -->

                            <a-alert
                                v-if="error_msg"
                                :message="error_msg"
                                type="error"
                                show-icon
                                closable
                                class="alert-message"
                                @close="error_msg = ''"
                            />

                            <a-form-item>
                                <div class="password-label-container">
                                    <label class="password-label">Insira uma nova senha</label>
                                    <span
                                        class="password-strength-text"
                                        :class="password ? strengthClass : ''"
                                    >
                                        {{ password ? strengthText : "Força da senha" }}
                                    </span>
                                </div>

                                <StandardSimpleInput
                                    :error="fieldError"
                                    type="password"
                                    v-model="password"
                                    @input="onPasswordInput"
                                    @clear-error="fieldError = ''"
                                    placeholder="Digite sua senha"
                                    class="password-input"
                                />
                            </a-form-item>

                            <div class="password-strength">
                                <div
                                    v-for="n in 4"
                                    :key="n"
                                    :class="['bar', strengthLevel >= n ? strengthClass : '']"
                                ></div>
                            </div>

                            <ul class="password-rules">
                                <li :class="{ valid: validations.minLength }">
                                    Mínimo de 8 caracteres
                                </li>
                                <li :class="{ valid: validations.uppercase }">
                                    1 letra maiúscula (A-Z)
                                </li>
                                <li :class="{ valid: validations.lowercase }">
                                    1 letra minúscula (a-z)
                                </li>
                                <li :class="{ valid: validations.number }">1 número (0-9)</li>
                                <li :class="{ valid: validations.special }">
                                    1 caractere especial (ex: @, #, $, &)
                                </li>
                            </ul>

                            <a-form-item>
                                <StandardSimpleInput
                                    :label="'Confirme sua nova senha'"
                                    :error="fieldError"
                                    type="password"
                                    v-model="confirmPassword"
                                    @clear-error="fieldError = ''"
                                    placeholder="Digite sua senha"
                                    class="password-input"
                                />
                            </a-form-item>

                            <a-form-item class="submit-button-container">
                                <AuthSubmitButton
                                    :loading="loading"
                                    :default-text="'Criar nova senha'"
                                    :loading-text="'Salvando...'"
                                    type="submit"
                                    @click.native="submitNewPassword"
                                    class="submit-button"
                                />
                            </a-form-item>
                            <AuthBackLink />
                        </div>

                        <div class="sucess-feedback" v-else>
                            <div class="success-header" v-if="showSuccess && !accountSuspended">
                                <h3>Senha Recuperada!</h3>
                                <span class="success-subtitle">
                                    Sua nova senha foi criada com sucesso. Realize o login novamente
                                    para entrar no Club!
                                </span>

                                <a-form-item class="success-button">
                                    <AuthSubmitButton
                                        :loading="loading"
                                        :default-text="'Ir para o login'"
                                        :loading-text="'Carregando...'"
                                        type="submit"
                                        @click.native="goToLogin"
                                        class="submit-button"
                                    />
                                </a-form-item>
                            </div>
                            <div class="success-header" v-else-if="accountSuspended">
                                <h3>Conta Suspensa!</h3>
                                <p class="success-subtitle">
                                    Para proteger sua conta e nossos sistemas, o acesso foi
                                    temporariamente suspenso. Essa ação pode ter sido tomada devido
                                    a várias tentativas de login, atividade incomum ou violação de
                                    nossos termos.
                                </p>
                                <p class="success-subtitle">
                                    Para reativar sua conta, entre em contato com nosso time de
                                    suporte. Eles ajudarão a verificar a situação e restaurar seu
                                    acesso o mais breve possível.
                                </p>

                                <a-form-item class="success-button">
                                    <AuthSubmitButton
                                        :loading="loading"
                                        :default-text="'Entra em contato com o suporte'"
                                        :loading-text="'Carregando...'"
                                        type="submit"
                                        @click.native="contactSupport"
                                        class="submit-button"
                                    />
                                </a-form-item>
                            </div>
                            <AuthBackLink />
                        </div>
                    </div>
                    <AuthFooter @privacy-click="showPrivacyModal" />
                </div>
            </div>
        </div>
        <PrivacyModal v-if="showPrivacy" :value="showPrivacy" @input="showPrivacy = $event" />
    </div>
</template>
<script>
import PrivacyModal from "@/modals/privacy-modal/privacyModal.vue";
import StandardSimpleInput from "@/components/ui/inputs/inputSimple.component.vue";
import AuthFooter from "@/components/partials/AuthFooter.vue";
import AuthBackLink from "@/components/partials/AuthBackLink.vue";
import AuthSubmitButton from "@/components/ui/buttons/submitButton.component.vue";
import CodeInput from "@/components/ui/inputs/codeInput.component.vue";
import ClientServiceV3 from "@/services/v3/auth.service";
import { mapState } from "vuex";

export default {
    name: "ResetPassword",
    components: {
        PrivacyModal,
        StandardSimpleInput,
        AuthFooter,
        AuthBackLink,
        AuthSubmitButton,
        CodeInput,
    },
    data() {
        return {
            currentStep: "reset-email",
            recoveryType: "whatsapp",
            contact: "",
            error_msg: "",
            loading: false,
            showPrivacy: false,
            resendDisabled: false,
            success_msg: "",
            fieldError: "",
            resendTimer: 30,
            resendInterval: null,
            clientServiceV3: new ClientServiceV3(),
            password: "",
            confirmPassword: "",
            accountSuspended: false,
            showPasswordRules: false,
            verificationToken: "",
            validations: {
                minLength: false,
                uppercase: false,
                lowercase: false,
                number: false,
                special: false,
            },
            showSuccess: false,
        };
    },
    computed: {
        maskedContact() {
            if (!this.contact) return "";

            if (this.recoveryType === "email") {
                const [username, domain] = this.contact.split("@");
                if (!username || !domain) return this.contact;

                return `${username.substring(0, 2)}***@${domain}`;
            }

            const phone = this.contact.replace(/\D/g, "");
            if (phone.length <= 4) return phone;

            return `${phone.substring(0, 2)}****-${phone.slice(-2)}`;
        },
        strengthLevel() {
            return Object.values(this.validations).filter(Boolean).length;
        },

        strengthText() {
            switch (this.strengthLevel) {
                case 0:
                case 1:
                    return "Muito Fraca";
                case 2:
                    return "Fraca";
                case 3:
                case 4:
                    return "Boa";
                case 5:
                    return "Forte";
                default:
                    return "";
            }
        },

        strengthClass() {
            switch (this.strengthLevel) {
                case 0:
                case 1:
                    return "very-weak";
                case 2:
                    return "weak";
                case 3:
                case 4:
                    return "good";
                case 5:
                    return "strong";
                default:
                    return "";
            }
        },
        isPasswordValid() {
            return Object.values(this.validations).every(Boolean);
        },
        ...mapState(["whitelabel"]),
    },
    beforeDestroy() {
        if (this.resendInterval) {
            clearInterval(this.resendInterval);
        }
    },
    methods: {
        onPhoneInput(value) {
            let digits = value.replace(/\D/g, "");

            if (digits.length <= 2) {
                this.contact = digits;
                return;
            }

            if (digits.length <= 6) {
                this.contact = `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
                return;
            }

            if (digits.length <= 10) {
                this.contact = `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
                return;
            }

            this.contact = `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
        },
        validateContact() {
            if (!this.contact) {
                this.fieldError =
                    this.recoveryType === "email"
                        ? "Email é obrigatório"
                        : "WhatsApp é obrigatório";
                return false;
            }

            if (this.recoveryType === "email") {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(this.contact)) {
                    this.fieldError = "Email inválido";
                    return false;
                }
            } else {
                const phone = this.contact.replace(/\D/g, "");
                if (phone.length < 10 || phone.length > 11) {
                    this.fieldError = "Número de WhatsApp inválido";
                    return false;
                }
            }

            this.fieldError = "";
            return true;
        },

        switchTowhatsApp() {
            this.recoveryType = "whatsapp";
            this.contact = "";
            this.error_msg = "";
            this.success_msg = "";
            this.fieldError = "";
        },

        switchToEmail() {
            this.recoveryType = "email";
            this.contact = "";
            this.error_msg = "";
            this.success_msg = "";
            this.fieldError = "";
        },

        showPrivacyModal() {
            this.showPrivacy = true;
        },

        handleSubmit() {
            if (!this.validateContact()) return;

            const value = this.contact.trim();

            if (value.includes("@")) {
                this.resetPassword({ email: value });
                return;
            }

            this.resetPassword({
                use_whatsapp: 1,
                phone: value.replace(/\D/g, ""),
            });
        },

        resetPassword(values) {
            this.loading = true;
            this.error_msg = "";
            this.success_msg = "";

            let payload = {};

            if (values.email) {
                payload = { email: values.email };
            } else if (values.phone) {
                payload = { use_whatsapp: 1, phone: values.phone.replace(/\D/g, "") };
            }

            this.clientServiceV3
                .requestReset(payload)
                .then((resp) => {
                    this.loading = false;
                    this.success_msg = "Código enviado com sucesso!";

                    setTimeout(() => {
                        this.currentStep = "verify-code";
                        this.startResendTimer();
                    }, 1000);
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.response?.data?.errors) {
                        this.error_msg = error.response.data?.errors?.join(" ");
                    } else {
                        this.error_msg = "Erro ao solicitar recuperação de senha.";
                    }
                });
        },

        startResendTimer() {
            this.resendDisabled = true;
            this.resendTimer = 30;

            this.resendInterval = setInterval(() => {
                this.resendTimer--;
                if (this.resendTimer <= 0) {
                    this.resendDisabled = false;
                    clearInterval(this.resendInterval);
                }
            }, 1000);
        },

        async resendCode() {
            if (this.resendDisabled) return;

            this.loading = true;
            this.error_msg = "";
            this.success_msg = "";

            let payload = {};

            if (this.recoveryType === "email") {
                payload = { email: this.contact };
            } else {
                payload = {
                    use_whatsapp: 1,
                    phone: this.contact.replace(/\D/g, ""),
                };
            }

            try {
                const response = await this.clientServiceV3.requestReset(payload);

                this.loading = false;

                if (response.data && response.data.success) {
                    this.success_msg = "Código reenviado com sucesso!";
                    this.startResendTimer();
                }
            } catch (error) {
                this.loading = false;
                if (error.response?.data?.errors) {
                    this.error_msg = error.response.data?.errors?.join(" ");
                } else if (error.response?.status === 429) {
                    this.error_msg = "Muitas tentativas. Tente novamente em alguns minutos.";
                } else {
                    this.error_msg = "Erro ao reenviar código. Tente novamente.";
                }
            }
        },
        async handleCodeComplete(code) {
            this.loading = true;
            this.error_msg = "";
            this.success_msg = "";

            const data = { token: code };

            if (this.recoveryType === "email") {
                data.email = this.contact;
            } else {
                data.phone = this.contact.replace(/\D/g, "");
            }

            try {
                await this.clientServiceV3.validateToken(data);
                this.verificationToken = code;
                this.currentStep = "password-change";
            } catch (error) {
                this.verificationToken = "";
                if (error.response?.data?.message) {
                    this.error_msg = error.response.data.message;
                } else {
                    this.error_msg = "Código inválido ou expirado. Tente novamente.";
                }
            } finally {
                this.loading = false;
            }
        },
        backToReset() {
            this.currentStep = "reset-email";
            this.error_msg = "";
            this.success_msg = "";
            this.verificationToken = "";
            if (this.resendInterval) {
                clearInterval(this.resendInterval);
            }
        },
        onPasswordInput(value) {
            this.password = value;
            this.showPasswordRules = value.length > 0;
            this.validatePassword();
        },
        validatePassword() {
            const val = this.password;
            this.validations = {
                minLength: val.length >= 8,
                uppercase: /[A-Z]/.test(val),
                lowercase: /[a-z]/.test(val),
                number: /[0-9]/.test(val),
                special: /[^A-Za-z0-9]/.test(val),
            };
        },
        submitNewPassword() {
            if (!this.isPasswordValid) {
                this.error_msg = "A senha não atende aos requisitos mínimos.";
                return;
            }

            if (this.password !== this.confirmPassword) {
                this.error_msg = "As senhas não coincidem.";
                return;
            }

            if (!this.verificationToken) {
                this.error_msg =
                    "Token de verificação não encontrado. Por favor, volte e insira o código novamente.";
                return;
            }

            this.loading = true;
            this.error_msg = "";

            const payload = {
                token: this.verificationToken,
                password: this.password,
                password_confirmation: this.confirmPassword,
            };

            this.clientServiceV3
                .newPassword(payload)
                .then((response) => {
                    this.loading = false;

                    if (response.data && response.data.accountSuspended) {
                        this.accountSuspended = true;
                    } else {
                        this.showSuccess = true;
                        this.success_msg = "Senha alterada com sucesso!";
                    }
                })
                .catch((error) => {
                    this.loading = false;

                    if (error.response && error.response.status === 423) {
                        this.accountSuspended = true;
                    } else if (error.response?.data?.errors) {
                        this.error_msg = error.response.data?.errors?.join(" ");
                    } else {
                        this.error_msg = "Erro ao alterar senha. Tente novamente.";
                    }
                });
        },
        contactSupport() {
            window.location.href = "mailto:support@club.com";
        },
        goToLogin() {
            this.$router.push("/login");
        },
        showPrivacyModal() {
            this.showPrivacy = true;
        },
        syncUrl() {
            const query = {
                ...this.$route.query,
                step: this.currentStep,
                type: this.recoveryType,
                contact: this.contact,
            };

            // Remove empty values
            Object.keys(query).forEach((key) => {
                if (!query[key]) delete query[key];
            });

            this.$router
                .replace({
                    query,
                })
                .catch(() => {});
        },
    },
    created() {
        if (this.$route.query.showPolicy) {
            this.visiblePolicy = true;
        }

        if (this.$route.query.step) {
            this.currentStep = this.$route.query.step;
        }

        if (this.$route.query.type) {
            this.recoveryType = this.$route.query.type;
        }

        if (this.$route.query.contact) {
            this.contact = this.$route.query.contact;
        }

        if (this.currentStep === 'verify-code') {
            this.startResendTimer();
        }
    },
    watch: {
        currentStep(val) {
            this.syncUrl();
            if (val === "verify-code") {
                this.startResendTimer();
            }
        },
        contact() {
            this.syncUrl();
        },
        recoveryType() {
            this.syncUrl();
        },
    },
};
</script>

<style lang="scss" scoped>
.reset-page {
    height: 100vh;
    width: 100%;
    background: #fafafa;
}

.reset-page-container {
    height: 100vh;
    width: 100%;
    display: flex;
    margin: 0 auto;
}

.reset-container {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    margin: 0 auto;

    .logo-auth {
        width: 188px;
        padding-top: 30px;
    }
    .img-logotipo-whitelabel {
        width: 100px;
        padding-top: 30px;
    }
}
.reset-container-form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100vh;
}
.reset-email,
.verify-code {
    width: 100%;
    max-width: 330px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 20px;

    h3 {
        color: #212121;
        font-weight: 700;
        font-size: 32px;
        line-height: 100%;
        margin: 0;
    }

    .form-subtitle {
        color: #605f5f;
        font-weight: 500;
        font-size: 14px;
        margin: 0;
    }
}

.reset-password-form {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.links-reset {
    color: #757575;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    line-height: 1.5;
    display: block;
    margin: 4px 0 4px 0;
    padding: 0;
    width: 100%;

    a {
        color: #ff5722;
        font-weight: 600;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }
}

.verify-container-form {
    display: flex;
    flex-direction: column;
    height: 100vh;
    justify-content: space-between;
}

.submit-button-code {
    background-color: #f5f5f5;
    border-color: #c7c9d9;
    font-weight: 600;
    color: #bdbdbd;
    font-size: 14px;
    margin: 10px 0;

    &:not(:disabled) {
        background-color: #eeeeee;
        border-color: #c7c9d9;
        color: #424242;
    }
}
.password-container-form {
    display: flex;
    flex-direction: column;
    height: 100vh;
    justify-content: space-between;
}
.password-form,
.sucess-feedback {
    max-width: 330px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 20px;
    h3 {
        font-size: 28px;
        font-weight: 700;
        color: #212121;
    }
    .form-subtitle {
        font-size: 14px;
        color: #605f5f;
        margin-bottom: 2px;
    }
}

.password-label-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.password-input {
    margin-bottom: 0;
    margin-top: 0;
}

.password-label {
    font-weight: 600;
    font-size: 14px;
    color: #757575;
    font-family: "DM Sans", sans-serif !important;
}

.password-strength {
    display: flex;
    gap: 5px;
    margin-top: 8px;
}
.bar {
    height: 5px;
    flex: 1;
    background-color: #e0e0e0;
    border-radius: 4px;
    transition: background-color 0.3s;

    &.very-weak {
        background-color: #d32f2f;
    }
    &.weak {
        background-color: #f57c00;
    }
    &.good {
        background-color: #81c784;
    }
    &.strong {
        background-color: #2e7d32;
    }
}

.password-rules {
    list-style: none;
    padding: 0;
    margin: 12px 0 16px 0;
    font-size: 14px;
    color: #757575;
}
.password-rules li {
    position: relative;
    padding-left: 20px;
    margin: 4px 0;
    transition: color 0.2s;
}
.password-rules li::before {
    content: "•";
    position: absolute;
    left: 0;
    color: #bdbdbd;
    font-size: 18px;
    line-height: 1;
}
.password-rules li.valid {
    color: #2e7d32;
    font-weight: 500;
}

.password-rules li.valid::before {
    content: "✓";
    color: #2e7d32;
}

.password-strength-title {
    font-size: 12px;
    color: #9e9e9e;
    margin-right: 4px;
}

.password-strength-text {
    font-size: 12px;
    font-weight: 400;
    color: #757575;
    margin-left: auto;

    &.very-weak {
        color: #d32f2f;
    }
    &.weak {
        color: #f57c00;
    }
    &.good {
        color: #81c784;
    }
    &.strong {
        color: #2e7d32;
    }
}

.success-button {
    margin-top: 2rem;
}

.submit-button-container {
    margin-top: 8px;
}
.submit-button {
    height: 42px;
    border-radius: 8px;
    background-color: #ff7043;
    border-color: #ff7043;
    font-weight: 600;
    color: #212121;

    &:hover,
    &:focus {
        background-color: #ff5722;
        border-color: #ff5722;
        color: #212121;
    }
}

.back-login {
    text-align: center;
    margin-top: 0px;

    .back-link {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #424242;
        font-weight: 600;
        gap: 8px;
        text-decoration: none;

        &:hover {
            color: #ff5722;
        }
    }
}

.footer {
    margin-top: 2rem;
    text-align: center;

    p {
        color: #757575;
        font-size: 12px;
        margin-bottom: 0.5rem;
    }

    .privacy-button {
        color: #ff5722;
        font-size: 12px;
        padding: 0;
        height: auto;
    }
}

.alert-message {
    margin-bottom: 16px;
}
</style>
